import { render, staticRenderFns } from "./LandParcelTable.vue?vue&type=template&id=9ed589a6&"
import script from "./LandParcelTable.vue?vue&type=script&lang=js&"
export * from "./LandParcelTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports